import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface IraState {
  iraData: {
    answer: string;
  } | null;
  isRegenerated: boolean;
  savedByIcon: boolean;
  newFlowIdByIcon: string;
  newIdByIcon: string;
  title: string;
}

const initialState: IraState = {
  iraData: null,
  isRegenerated: false,
  savedByIcon: false,
  newFlowIdByIcon: '',
  newIdByIcon: '',
  title: '',
};

const { name, reducer, actions } = createSlice({
  name: 'ira',
  initialState,
  reducers: {
    setIraData(state, action) {
      state.iraData = action.payload;
    },
    setIraRegenerated(state, action) {
      state.isRegenerated = action.payload as boolean;
    },
    setIraSavedByIcon(state, action) {
      state.savedByIcon = action.payload as boolean;
    },
    setIraNewFlowIdByIcon(state, action) {
      state.newFlowIdByIcon = action.payload as string;
    },
    setIraNewIdByIcon(state, action) {
      state.newIdByIcon = action.payload as string;
    },
    resetIraIconState(state) {
      state.savedByIcon = false;
      state.newFlowIdByIcon = '';
      state.newIdByIcon = '';
    },
    setIraTitle(state, action) {
      state.title = action.payload as string;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const {
  setIraData,
  setIraRegenerated,
  setIraSavedByIcon,
  setIraNewFlowIdByIcon,
  setIraNewIdByIcon,
  resetIraIconState,
  setIraTitle,
} = actions;

export {
  name,
  reducer,
  resetIraIconState,
  setIraData,
  setIraNewFlowIdByIcon,
  setIraNewIdByIcon,
  setIraRegenerated,
  setIraSavedByIcon,
  setIraTitle,
};

export const selectIraData = (state: State) => state[name].iraData;
export const selectIraRegenerated = (state: State) => state[name].isRegenerated;
export const selectIraSavedByIcon = (state: State) => state[name].savedByIcon;
export const selectIraNewFlowIdByIcon = (state: State) => state[name].newFlowIdByIcon;
export const selectIraNewIdByIcon = (state: State) => state[name].newIdByIcon;
export const selectIraTitle = (state: State) => state[name].title;
